import { useEffect, useState, useCallback } from "react";
import { useIdentity } from "base/identity-resolver";
import { buildDefaultQuery } from "../utils/default-contacts-query";
import useTableSettings from "hooks/use-table-settings";

const useJourneysContactFilters = (selectedJourney) => {
  const { user, org } = useIdentity();
  const [filters, setFilters] = useState({});
  const [isAllSelectedCheckbox, setIsAllSelectedCheckbox] = useState(false);

  const { tableSettings, updateTableSettings, resetTable } = useTableSettings();

  useEffect(() => {
    if (!selectedJourney) {
      return;
    }
    const defaultQuery = buildDefaultQuery(user, org, selectedJourney);
    setFilters(defaultQuery);
  }, [user, org, selectedJourney]);

  const setContactFilters = useCallback(
    (dsl, shouldResetTable = true) => {
      setFilters(dsl);
      if (shouldResetTable) resetTable();
    },
    [resetTable]
  );

  const filterCount =
    filters.filters &&
    filters.filters.blocks.reduce((acc, cur) => {
      if (cur.rules.length === 1 && Object.keys(cur.rules[0]).length === 0) {
        return acc;
      }
      return (acc += cur.rules.length);
    }, 0);

  return {
    filters,
    filterCount,

    setContactFilters,

    tableSettings,
    updateTableSettings,

    isAllSelectedCheckbox,
    setIsAllSelectedCheckbox,
  };
};

export default useJourneysContactFilters;
